import { createContext, useState, useContext, ReactNode, useEffect } from 'react';

interface LoadingContextType {
  loading: boolean;
  step: string
  subStep: string

  /** @deprecated use toggleLoading, changeStep, and changeSubStep */
  showLoading: () => void;
  /** @deprecated use toggleLoading, changeStep, and changeSubStep */
  hideLoading: () => void;

  changeStep: (state: string) => void;
  changeSubStep: (state: string) => void;

  toggleLoading: (state: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('Reticulating Splines')
  const [subStep, setSubStep] = useState('Initializing Crystal Ball')

  const showLoading = () => {
    setStep(undefined)
    setSubStep(undefined)
    setLoading(true)
  };
  const hideLoading = () => {
    setStep(undefined)
    setSubStep(undefined)
    setLoading(false)
  };
  
  const toggleLoading = (state: boolean) => setLoading(state);
  const changeStep = (state: string) => setStep(state)
  const changeSubStep = (state: string) => setSubStep(state)

  useEffect(() => {
    if(loading === false){
      changeStep(undefined)
      changeSubStep(undefined)
    }
  }, [loading])

  return (
    <LoadingContext.Provider value={{ loading, showLoading, hideLoading, toggleLoading, step, subStep, changeStep, changeSubStep }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useSpinner must be used within a SpinnerProvider');
  }
  return context;
};
